import { React } from "react";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";

import { useVerification } from "../../../../context/Verification.context";

export const InsuranceCard = ({ carrier }) => {
  const navigate = useNavigate();
  const verification = useVerification();

  return (
    <>
      <Box
        sx={{
          height: "80px",
          borderRadius: "16px",
          display: "flex",
          flexDirection: "row",
          boxShadow:
            "rgb(145 158 171 / 20%) 0px 0px 2px 0px,rgb(145 158 171 / 12%) 0px 12px 24px -4px",
          marginTop: "14px",
          cursor: "pointer",
          padding: "8px",
          border: "0.5px solid rgba(0,171,85,0.15)",
          "&:hover": {
            backgroundColor: "rgba(0,171,85,0.1)",
            cursor: "pointer",
          },
        }}
        onClick={() => {
          verification.setInsuranceProvider(
            JSON.stringify({ provider: carrier })
          );
          navigate(`/verification/providerLogin`, { replace: true });
        }}
      >
        <Box
          sx={{
            width: "80px",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(0,171,85,0.1)",
            border: "none",
          }}
        >
          <Typography
            variant="p"
            style={{
              margin: "8px",
              fontSize: "20px",
              fontWeight: "bold",
              color: "#009349",
            }}
          >
            {carrier.name.match(/\b(\w)/g).join("")}
          </Typography>
        </Box>
        <Box
          sx={{
            width: "100%",
            // height: "30%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onMouseOver={(e) => (e.target.style.overflowX = "visible")}
          onMouseLeave={(e) => (e.target.style.overflowX = "hidden")}
        >
          <Typography
            variant="p"
            fontWeight={"bold"}
            style={{
              overflowX: "hidden",
              color: "black",
              justifySelf: "center",
              textAlign: "center",
            }}
          >
            {carrier.name}
          </Typography>
        </Box>
      </Box>
    </>
  );
};
